module.exports = __webpack_public_path__ + "img/signup-bg5.54489f9c.png";